export default {"src":"/_next/static/media/icon-flag-england.d545e745.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};